import React from 'react'

import 'jquery-ui/themes/base/core.css'
import 'jquery-ui/themes/base/menu.css'
import 'jquery-ui/themes/base/autocomplete.css'
import 'jquery-ui/themes/base/theme.css'
import 'jquery-ui/ui/widgets/autocomplete'

import API from 'common/src/api'

class LocationInput extends React.Component {
  componentDidMount() {
    this.onAutocomplete()
  }

  onAutocomplete() {
    $(`.location-${this.props.guId}`).autocomplete({
      source: function (request, cb) {
        $.ajax($.extend(API.V3.suburbsGet({ 'filter[q]': request.term }), {
          beforeSend: cb([{ label: "Loading Matches...", loading: true }])
        }))
        .done(function(response) {
          let results = response.data.map( item => ({ value: item.attributes.fullName, id : parseInt(item.id, 10) }) )
          cb(results)
        })
        .fail(function() {
          document.location = "/500";
        })
      },
      select: this.props.handleAutocompleteSelection,
      open: function() {
        $('.ui-autocomplete').off('menufocus hover mouseover mouseenter');
      }
    })
  }

  render() {
    return(
      <input type="text"
        name="location"
        id={`location-${this.props.guId}`}
        className={`form-control location-${this.props.guId} ${this.props.inputClass}`}
        placeholder="Enter Postcode or Suburb"
        value={this.props.suburb}
        data-suburb-id={this.props.suburbId || "0"}
        onChange={this.props.handleLocationChange}
        autoFocus={this.props.autoFocus}
      />
    )
  }
}

export default LocationInput
